import React, { useLayoutEffect, useRef, useState } from 'react';

export default function SegmentedControl({
    className,
    selectedIndex = 0,
    options,
    onChange,
}) {
    const containerPaddingPx = 4;
    const totalVerticalPaddingPx = containerPaddingPx * 2;

    const containerRef = useRef(null);
    const buttonRefs = useRef([]);

    const [indicator, setIndicator] = useState({
        left: 0,
        width: 0,
    });

    const handleChange = (newIndex) => {
        if (newIndex === selectedIndex) return;
        onChange(newIndex, selectedIndex);
    };

    useLayoutEffect(() => {
        const button = buttonRefs.current[selectedIndex];
        const container = containerRef.current;
        if (!button || !container) return;

        setIndicator({
            left: ((button.offsetLeft - containerPaddingPx) / container.offsetWidth) * 100,
            width: (button.offsetWidth / container.offsetWidth) * 100,
        });
    }, [selectedIndex]);

    return (
        <div ref={containerRef} className={`segmented-control ${className}`} style={{ padding: `${containerPaddingPx}` }}>
            <div
                className="segmented-control__indicator"
                style={{
                    width: `${indicator.width}%`,
                    height: `calc(100% - ${totalVerticalPaddingPx}px)`,
                    left: `calc(${indicator.left}% + ${containerPaddingPx}px)`,
                }}
            />
            {options.map((option, index) => (
                <button
                    type="button"
                    className={`segmented-control__option-button ${selectedIndex === index ? 'segmented-control__option-button--selected' : ''}`}
                    key={option.value}
                    ref={(element) => {
                        buttonRefs.current[index] = element;
                    }}
                    onClick={() => handleChange(index)}
                >
                    {option.label}
                </button>
            ))}
        </div>
    );
}
